import { Box, HStack } from '@chakra-ui/react';
import React from 'react';
import { useTokens } from '../../../context/TokenProvider';
export const Chip = ({ isDisabled, children }) => {
    const tokens = useTokens();
    return (React.createElement(Box, { paddingY: tokens.Spacing02, paddingLeft: tokens.Spacing04, paddingRight: tokens.Spacing03, borderRadius: tokens.BorderRadius02, backgroundColor: tokens.CanvasInformationLight, borderColor: tokens.BorderMedium600, borderWidth: tokens.BorderWidth01, opacity: isDisabled ? 0.6 : 1 },
        React.createElement(HStack, null, children)));
};
